import GemMeterBaseRule from '../GemMeterBaseRule';
import { CAN_NOT_SEND_EMAIL } from '../../../constants/rulesConstants';

export default class InputFieldNameRule extends GemMeterBaseRule {
  static ruleId = CAN_NOT_SEND_EMAIL.id;

  static validate(selector: string) {
    const element = GemMeterBaseRule.getElement(selector);
    if (!element) {
      return true;
    }

    const nameAttribute = element.getAttribute('name') as string;

    return (
      nameAttribute !== undefined
      && typeof nameAttribute === 'string'
      && nameAttribute.length > 0
      && /^contact\[[a-z]{1}[a-z0-9_]+\]$/g.test(nameAttribute)
    );
  }
}
